/**
 * A percentage as the app prints it: a whole number with a "%" ("99%").
 *
 * One formatter for every score and progress figure on the Course page and
 * the module-complete card (PR #1075), so a lesson's "Score 99%" and its
 * module's "99% avg" are rounded the same way. The server keeps 2 dp; only
 * the display rounds.
 *
 * The ends are exact: a value below 100 never prints as "100%" (a 99.52%
 * average is not a perfect score; perfect has its own marker), and a value
 * above 0 never prints as "0%". A missing or non-finite value is "0%", so a
 * caller can never print "NaN%" or a bare "%".
 */
export function formatPercent(value: number | null | undefined): string {
  if (typeof value !== 'number' || !Number.isFinite(value)) return '0%';
  const clamped = Math.min(100, Math.max(0, value));
  let whole = Math.round(clamped);
  if (whole === 100 && clamped < 100) whole = 99;
  if (whole === 0 && clamped > 0) whole = 1;
  return `${whole}%`;
}
